<!-- Features Start -->
<section class="section" id="features">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
                <div class="title text-center mb-5">
                    <h3 class="font-weight-normal text-dark">Nuestras <span class="text-warning">Ventajas</span></h3>
                    <p class="text-muted">Queremos que conozcas algunas de las ventajas de trabajar con nuestro equipo.</p>
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-5" style="background: url(assets/images/features/features-bg.png) center center">
                <div class="features-img">
                    <img src="assets/images/features/img-1.png" alt="" class="img-fluid d-block mx-auto">
                </div>
            </div>
            <div class="col-md-6 offset-md-1">
                <div class="features-box mt-5 mt-sm-0 mb-4">
                    <div class="features-icon my-4">
                        <i class="mdi mdi-laptop-mac"></i>
                    </div>
                    <h5 class="text-dark font-weight-normal mb-3 pt-3">Desarrollo FullStack</h5>
                    <p class="text-muted mb-3 f-15">Desarrollamos la imprementación completa, desde el Frontend, Backend, Api Rest, hasta la interfaz gráfica y todo su UI y UX, hasta la modelación de datos. Con tu servidor propio o Cloud Computing tu eliges!</p>
                </div>
            </div>
        </div>

        <div class="row align-items-center mt-5">
            <div class="col-md-6">
                <div class="features-box mb-4">
                    <div class="features-icon my-4">
                        <i class="mdi mdi-account-group"></i>
                    </div>
                    <h5 class="text-dark font-weight-normal mb-3 pt-3">Soporte</h5>
                    <p class="text-muted mb-3 f-15">Contamos con un equipo de asesores que te brindaran el soporte oportuno para las dudas o problemas que tengas.</p>
                </div>
            </div>
            <div class="col-md-5 offset-md-1 mt-5 mt-sm-0" style="background: url(assets/images/features/features-bg.png) center center">
                <div class="features-img">
                    <img src="assets/images/features/img-2.png" alt="" class="img-fluid d-block mx-auto">
                </div>
            </div>
        </div>

        <div class="row align-items-center mt-5">
            <div class="col-md-5" style="background: url(assets/images/features/features-bg.png) center center">
                <div class="features-img">
                    <img src="assets/images/features/img-3.png" alt="" class="img-fluid d-block mx-auto">
                </div>
            </div>
            <div class="col-md-6 offset-md-1">
                <div class="features-box mt-5 mt-sm-0 mb-4">
                    <div class="features-icon my-4">
                        <i class="mdi mdi-chart-bell-curve"></i>
                    </div>
                    <h5 class="text-dark font-weight-normal mb-3 pt-3">Análisis Profundo</h5>
                    <p class="text-muted mb-3 f-15">Analizamos a profundidad la necesidad de tu negocio para ofrecerte las altenativas más innovadoras del mercado, con los mejores resultados. 100% personalisables</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Features End -->
